<section>
  <h3 class="main-title">רשימת הרכיבים במערכת</h3>
  <table
    mat-table
    class="mat-elevation-z4 boundary"
    cdkDropList
    [dataSource]="fireAlarmComponents"
    [cdkDropListData]="fireAlarmComponents"
    [cdkDropListDisabled]="readonly || printPreview"
    (cdkDropListDropped)="drop($event)"
  >
    <ng-container matColumnDef="drag">
      <th mat-header-cell *matHeaderCellDef></th>
      <td
        mat-cell
        *matCellDef="let element"
        cdkDrag
        cdkDragRootElement="tr"
        cdkDragLockAxis="y"
        cdkDragBoundary=".boundary"
        [cdkDragData]="element"
      >
        <div cdkDragHandle class="drag-handle">
          <authority-labs-drag-icon></authority-labs-drag-icon>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef>סוג</th>
      <td mat-cell *matCellDef="let element">
        <mat-form-field>
          <textarea
            matInput
            class="text"
            cdkTextareaAutosize
            name="type"
            [(ngModel)]="element.type"
            [readonly]="readonly || printPreview"
            (input)="onChange()"
          ></textarea>
        </mat-form-field>
      </td>
    </ng-container>
    <ng-container matColumnDef="model">
      <th mat-header-cell *matHeaderCellDef>דגם</th>
      <td mat-cell *matCellDef="let element">
        <mat-form-field>
          <textarea
            matInput
            class="text"
            cdkTextareaAutosize
            name="model"
            [(ngModel)]="element.model"
            [readonly]="readonly || printPreview"
            (input)="onChange()"
          ></textarea>
        </mat-form-field>
      </td>
    </ng-container>
    <ng-container matColumnDef="manufacture">
      <th mat-header-cell *matHeaderCellDef>תוצרת</th>
      <td mat-cell *matCellDef="let element">
        <mat-form-field>
          <input
            matInput
            class="text"
            cdkTextareaAutosize
            name="manufacture"
            [(ngModel)]="element.manufacture"
            [readonly]="readonly || printPreview"
            (input)="onChange()"
          />
        </mat-form-field>
      </td>
    </ng-container>
    <ng-container matColumnDef="notes">
      <th mat-header-cell *matHeaderCellDef>הערות</th>
      <td mat-cell *matCellDef="let element">
        <mat-form-field>
          <textarea
            matInput
            class="text"
            cdkTextareaAutosize
            name="notes"
            [(ngModel)]="element.notes"
            [readonly]="readonly || printPreview"
            (input)="onChange()"
          ></textarea>
        </mat-form-field>
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>
        <button
          mat-icon-button
          [matMenuTriggerFor]="mainmenu"
          *ngIf="!readonly"
        >
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #mainmenu="matMenu">
          <button mat-menu-item (click)="addExisting()">הוסף רכיב קיים</button>
          <button mat-menu-item (click)="addNew()">הוסף רכיב חדש</button>
        </mat-menu>
      </th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button [matMenuTriggerFor]="menu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item *ngIf="!readonly" (click)="remove(element)">
            הסר
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</section>
